// components/FormErrors.jsx
import { AlertCircle, X } from "lucide-react";
import { useState, useEffect } from "react";

export default function FormErrors({ errors, param }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(true);
  }, [errors]);

  if (!errors || errors.length === 0) return null;
  

  const filteredErrors = param 
    ? errors.filter(error => error.param === param)
    : errors.filter(error => !error.param || error.param === 'non_field_errors');

    

  if (filteredErrors.length === 0) return null;

  return (
    <div className={`
      ${visible ? 'opacity-100' : 'opacity-0'}
      transition-opacity duration-300
    `}>
      {filteredErrors.map((error, index) => (
        <div
          key={index}
          className={`
            ${param ? 'mt-1 text-sm' : 'mb-4'}
            flex items-start
            ${param ? 'text-red-600' : 'p-3 bg-red-50 border border-red-200 rounded-lg'}
          `}
        >
          {!param && (
            <AlertCircle className="w-4 h-4 text-red-500 mt-0.5 mr-2 flex-shrink-0" />
          )}
          <span className={param ? '' : 'text-sm text-red-700 flex-1'}>
            {error.message}
          </span>
          {!param && (
            <button
              type="button"
              onClick={() => setVisible(false)}
              className="ml-2 text-red-400 hover:text-red-600 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      ))}
    </div>
  );
}